/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N3Inputs */

const en_to_yaml_ref_n3 = /** @type {(inputs: To_Yaml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoted to protect the trailing zero. Unquoted it would parse as the number 1.1.`)
};

const ko_to_yaml_ref_n3 = /** @type {(inputs: To_Yaml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤의 0을 지키려고 인용됩니다. 인용하지 않으면 숫자 1.1로 파싱됩니다.`)
};

const ja_to_yaml_ref_n3 = /** @type {(inputs: To_Yaml_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`末尾のゼロを守るため引用されます。引用しないと数値 1.1 としてパースされます。`)
};

/**
* | output |
* | --- |
* | "Quoted to protect the trailing zero. Unquoted it would parse as the number 1.1." |
*
* @param {To_Yaml_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n3 = /** @type {((inputs?: To_Yaml_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n3(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n3(inputs)
	return ja_to_yaml_ref_n3(inputs)
});